export default __webpack_public_path__ + "static/media/accountingReportScreenshot.deb7c8bd.png";